module.exports = function () {
  var menu_items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "<div class=\"menu m".concat(menu_items, " hide-scrollbar\">").concat(html, "</div>");
};